import { createContext } from 'react'
import { LeadgenWithBannerProps, ModalType } from '.'

export type LeadgenWithBannerContextType = {
  close: () => void
  isFullscreenModal?: boolean
  modalType: ModalType
} & LeadgenWithBannerProps

export const LeadgenWithBannerContext = createContext<LeadgenWithBannerContextType>(
  {} as LeadgenWithBannerContextType,
)
